module.exports = __webpack_public_path__ + "img/bg-main.59420b84.jpg";